module.exports = __webpack_public_path__ + "static/media/abstrato-6.32eb1c5a.jpg";